import React from 'react';
import { Code, Database, Settings, Zap, MessageSquare, CheckCircle2 } from 'lucide-react';

const Skills = ({ t }) => {
  const skillCategories = [
    {
      icon: Code,
      title: t.skills.languages.title,
      items: t.skills.languages.items,
      color: '#d9fb06'
    },
    {
      icon: Database,
      title: t.skills.backend.title,
      items: t.skills.backend.items,
      color: '#d9fb06'
    },
    {
      icon: Settings,
      title: t.skills.sap.title,
      items: t.skills.sap.items,
      color: '#d9fb06'
    },
    {
      icon: Zap,
      title: t.skills.automation.title,
      items: t.skills.automation.items,
      color: '#d9fb06'
    },
    {
      icon: MessageSquare,
      title: t.skills.messaging.title,
      items: t.skills.messaging.items,
      color: '#d9fb06'
    },
    {
      icon: CheckCircle2,
      title: t.skills.practices.title,
      items: t.skills.practices.items,
      color: '#d9fb06'
    }
  ];

  return (
    <section id="skills" className="skills-section">
      <div className="container">
        <h2 className="section-title">{t.skills.title}</h2>
        
        <div className="skills-grid">
          {skillCategories.map((category, index) => {
            const Icon = category.icon;
            return (
              <div key={index} className="skill-card">
                <div className="skill-icon">
                  <Icon size={32} color={category.color} />
                </div>
                <h3 className="skill-title">{category.title}</h3>
                <ul className="skill-list">
                  {category.items.map((item, idx) => (
                    <li key={idx} className="skill-item">{item}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;